import { render, staticRenderFns } from "./TabAssignAssessor.vue?vue&type=template&id=55e61d5c&scoped=true&"
import script from "./TabAssignAssessor.vue?vue&type=script&lang=js&"
export * from "./TabAssignAssessor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e61d5c",
  null
  
)

export default component.exports